import { Card, CardContent, Typography, styled, Box, Chip } from '@mui/material';

const TagCard = styled(Card)(({ theme }) => ({
  background: theme.palette.background.paper,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

interface PopularTagsWidgetProps {
  tags: {
    name: string;
    count: number;
  }[];
}

export const PopularTagsWidget = ({ tags }: PopularTagsWidgetProps) => {
  return (
    <TagCard>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
          Популярные теги
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {tags.map((tag) => (
            <Chip
              key={tag.name}
              label={`${tag.name} (${tag.count})`}
              sx={{
                background: 'linear-gradient(90deg, #6e3bff, #ff3bff)',
                color: 'white',
                fontWeight: 'bold',
              }}
            />
          ))}
        </Box>
      </CardContent>
    </TagCard>
  );
};